import {
  DialogDescription,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogClose,
  Button,
  Dialog,
} from '@ui/components';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

import { useSkipOnboarding } from './use-skip-onboarding';

export const SkipOnboardingDialog: FC<{
  onOpenChange: (open: boolean) => void;
  open: boolean;
}> = ({ open, onOpenChange }) => {
  const { skipOnboardingMutation, isSkippingOnboarding } = useSkipOnboarding();
  const { t } = useTranslation();

  return (
    <Dialog
      onOpenChange={(open) => {
        onOpenChange(open);
      }}
      open={open}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('ONBOARDING.SKIP_ONBOARDING_DIALOG.TITLE')}</DialogTitle>
        </DialogHeader>

        <DialogDescription>{t('ONBOARDING.SKIP_ONBOARDING_DIALOG.DESCRIPTION')}</DialogDescription>

        <DialogFooter className="flex justify-between gap-3">
          <DialogClose asChild>
            <Button variant="tertiary" wide>
              {t('ONBOARDING.SKIP_ONBOARDING_DIALOG.CANCEL')}
            </Button>
          </DialogClose>
          <Button onClick={() => skipOnboardingMutation()} isLoading={isSkippingOnboarding} wide>
            {t('ONBOARDING.SKIP_ONBOARDING_DIALOG.SKIP')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
